<template>
  <div class="border">
    <div>
      <div v-if="ineted">
        <div v-if="order && partner && checked === true">
          <button @click="selectPartner" class="btn btn-danger mr-2">
            {{ "close_button" | setText("Вернуться к заказу") }}
          </button>

          <button
            v-if="
              partner &&
              transaction &&
              transaction.client_confirmed &&
              transaction.system_confirmed &&
              transaction.status != -1
            "
            @click="deleteRequest"
            class="btn btn-danger mr-2"
          >
            <span class="icon ti-info"></span>
            {{ "cancel_query" | setText("Запросить отмену") }}
          </button>

          <br />

          <br />
          <component
            v-if="partner && access"
            @close="selectPartner"
            :transaction="transaction"
            :is="partner.code"
            :partner_id="partner.id"
            :order="order"
            :partner="partner"
            :updateOrder="updateOrder"
            @setFirstCustomer="setFirstCustomer"
            :createTransaction="createTransaction"
          />

          <div v-else>
            <h3 class="text-danger">
              К сожалению, невозможно продолжить оформление заказа, так как
              данная акция не соответствует условиям выбранного вами метода
              оплаты.
            </h3>

            <h4>Вернитесь и отмените акцию</h4>
          </div>
        </div>
        <div v-else>
          <h4>{{ "select_partner" | setText("Выберите партнера") }}</h4>
          <list
            :additionalId="id"
            :columns="columns"
            :modalCreate="modalCreate"
            :removeLink="removeLink"
            :cardLink="cardLink"
            :itemLink="itemLink"
            :setLink="setLink"
            :openItem="true"
            :fields="fields"
            :params="params"
            :simple="true"
            :searchDisable="true"
            @change="change"
            @changeFunction="changeFunction"
            @input="selectPartner"
          />
        </div>
      </div>
      <div v-if="!partner" class="mt-4">
        <h4>Процессы по оплатам:</h4>
        <div class="">
          <ul class="row">
            <li
              class="col-12 col-md-6 col-lg-4"
              v-for="(transactionItem, key) in order.transactions"
              :key="key"
            >
              <div
                v-if="transactionItem && transactionItem.partner"
                class="border text-center"
              >
                <div>
                  <h3
                    v-if="
                      transactionItem.client_confirmed &&
                      transactionItem.system_confirmed
                    "
                  >
                    <i class="ti-check" />
                  </h3>
                  <h3 v-else-if="transactionItem.status == '-1'">
                    <i class="ti-close" />
                  </h3>
                  <h3 v-else><i class="ti-reload" /></h3>
                </div>
                <div class="mb-3">
                  <h5>{{ transactionItem.partner.name }}</h5>
                </div>

                <div>
                  <button
                    @click="selectPartner([transactionItem.partner])"
                    class="btn btn-sm btn-info w-100"
                  >
                    Детали
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <services
          v-if="order && order.order_services && order.order_services.length"
          :data="order.order_services"
          :transactions="order.transactions"
        />

        <div class="mt-5">
          <h4>Заверешение процесса</h4>
          <p class="mb-3 text-info" v-if="order.status">
            Текущий статус: <span>{{ order.status.name }}</span>
          </p>

          <div class="mb-3">
            <button
              :disabled="order.status && order.status.code === 'success'"
              @click="doneOrder()"
              class="btn btn-success mw"
            >
              Завершить заказ
            </button>
          </div>
          <div>
            <button
              :disabled="order.status && order.status.code === 'cancel'"
              @click="cancelOrder()"
              class="btn btn-danger mw"
            >
              Отменить заказ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, masState } from "vuex";
import { errorNotify } from "@/plugins/functions";
import { logger } from "../../plugins/functions";
import Services from "./Services.vue";
export default {
  computed: {
    ...mapState(["lastUpdate"]),
  },
  components: {
    paymart: () => import("@/components/Partners/paymart"),
    variant: () => import("@/components/Partners/variant"),
    intend: () => import("@/components/Partners/intend"),
    alif: () => import("@/components/Partners/alif"),
    iman: () => import("@/components/Partners/iman"),
    tbc: () => import("@/components/Partners/tbc"),
    "iman-v2": () => import("@/components/Partners/iman-v2"),
    "uzum-nasiya": () => import("@/components/Partners/uzum-nasiya"),
    "uzum-mko": () => import("@/components/Partners/uzum-mko"),
    "all-good-nasiya": () => import("@/components/Partners/all-good-nasiya"),
    cash: () => import("@/components/Partners/cash"),
    uzcard: () => import("@/components/Partners/uzcard"),
    humo: () => import("@/components/Partners/cash"),
    "alif-v1": () => import("@/components/Partners/alif-v1"),
    Services,
  },
  props: ["id", "price", "order"],
  name: "products",
  async created() {
    try {
      if (this.$route.query["partner"]) {
        let query = Object.assign({}, this.$route.query);
        let partner = await this.$http.get(`partners/${query["partner"]}`);
        if (query["partner"]) {
          delete query["partner"];
        }
        setTimeout(() => {
          this.$router.replace({ query: query });
          this.selectPartner([partner.data.data]);
        }, 50);
      }
    } catch (error) {}

    if (this.id) {
      this.load();
    }
  },
  watch: {
    lastUpdate(val) {
      if (val) {
        this.load();
      }
    },
  },
  methods: {
    async doneOrder() {
      await this.updateOrder({ status_id: 6 });
    },
    async cancelOrder() {
      await this.updateOrder({ status_id: 3 });
    },
    setFirstCustomer(val) {
      this.first_customer = val;
    },
    setStart() {},
    deleteRequest() {
      this.$loading(true);
      this.$http({
        url: `orders/${this.id}/transactions`,
        method: "POST",
        data: { request_delete: true, partner_id: this.partner.id },
      })
        .then((response) => {
          alert("Запрос успешно отправлен");
          this.$loading(false);
        })
        .catch((error) => {
          this.$loading(false);
          errorNotify(error, this.$notify);
        });
    },
    createTransaction(val) {
      if (this.partner) {
        let data = {
          ...val,
          partner_id: this.partner.id,
          first_customer: this.first_customer == true ? 1 : 0,
        };

        let dataSend = new FormData();

        Object.keys(data).forEach((key) => {
          dataSend.append(key, data[key]);
        });

        this.$loading(true);

        this.$http({
          url: `orders/${this.id}/transactions`,
          method: "POST",
          data: dataSend,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            this.transaction = response.data.data;
            this.$store.dispatch("setLastUpdate", new Date());
          })
          .catch((error) => {
            this.$loading(false);
            errorNotify(error, this.$notify);
          });
      }
    },
    selectPartner(val) {
      this.access = true;

      let alreadyPaid = false;

      if (this.order && this.order.transactions) {
        this.order.transactions.forEach((item) => {
          if (
            item.client_confirmed &&
            item.system_confirmed &&
            val &&
            val.length &&
            val[0].id != item.partner.id
          ) {
            alreadyPaid = true;
          }
        });
      }

      if (alreadyPaid) {
        this.$notify({
          title: "Внимание",
          message: "Заказ уже оплачен",
          type: "warning",
        });
        return false;
      }

      this.$loading(true);
      if (val && val.length) {
        this.partner = val[0];
        logger(this.$http, {
          name: `Выбор партнера ${this.partner.name}`,
          model_type: "order",
          model_id: this.id,
          description: `Заказ # ${this.id}`,
        });

        this.$http
          .get(`check/orders/${this.id}/${this.partner.id}`)
          .then((response) => {
            this.transaction = response.data.data;
            this.first_customer = this.transaction["first_customer"];
          })
          .catch((error) => {
            if (error.response.status == 403) {
              this.access = false;
            }

            this.transaction = null;
          })
          .finally(() => {
            this.checked = true;
            this.$emit("close", this.checked);
            this.$loading(false);
          });
      } else {
        // this.partner_code = '';
        // this.partner_id = '';
        this.partner = null;
        this.checked = false;
        this.$emit("close", this.checked);
      }
    },
    async updateOrder(val) {
      this.$loading(true);
      await this.$http
        .put(`orders/${this.id}`, val)
        .then((response) => {
          this.$emit("updateOrder", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    changeFunction(val) {},
    change(val) {},
    load() {
      this.$emit("updateOrder", true);
    },
  },
  data() {
    return {
      access: true,
      ineted: true,
      partnerList: [],
      checked: false,
      first_customer: false,
      // partner_id: null,
      // partner_code: null,
      // order: null,
      transaction: null,
      params: {},
      val: {},
      partner: null,
      modalCreate: "season",
      fields: [
        {
          col: " col-12 col-md-6",
          key: "name",
          label: "Название",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-6",
          key: "code",
          label: "Ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "type_auth",
          label: "Тип авторизации",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "api_secret_key",
          label: "Секретный ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "api_public_key",
          label: "Публичный ключ",
          type: "field",
          textType: "text",
        },
        {
          col: " col-12 col-md-12",
          key: "endpoint_url",
          label: "Endpoint URL",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_calc",
      itemLink: "partners",
      setLink: "partners",
      columns: [
        {
          key: "name",
          checkbox: true,
          title: "Название",
        },

        // {
        //   info: true,

        // },
      ],
    };
  },
};
</script>
<style>
</style>
